import { Modal } from 'bootstrap';
import { Dropdown } from 'bootstrap';
import { Collapse } from 'bootstrap';
import { Alert } from 'bootstrap';
import { Tooltip } from 'bootstrap';
import { Offcanvas } from 'bootstrap';
import AOS from 'aos';
import Videoplayer from './video';

window.$ = window.jQuery = jQuery;
window.bootstrap = {};
window.bootstrap.Offcanvas = Offcanvas;

AOS.init();

// activate scheduled seminar dates tab, if the search/pagination has been used
if (window.location.search.indexOf('tx_rxseminars_seminardatelist%5B') > 0 || window.location.search.indexOf('tx_rxseminars_seminardatesearchfilter%5B') > 0) {
  $(() => {
    const $inquiry = $('#scheduled-tab');
    if ($inquiry) {
      $inquiry.click();
    }
  });
}

// Add bg-color to h5p iframe if Section Learning Step has bg-color
window.addEventListener("load", () => {
  const sectionLearningStepBgColorIframes = document.querySelectorAll(".section-learning-step.bg-dark iframe.h5p-iframe");
  if (sectionLearningStepBgColorIframes) {
    for (let i = 0; i < sectionLearningStepBgColorIframes.length; i++) {
      const iframeContent = sectionLearningStepBgColorIframes[i].contentDocument || sectionLearningStepBgColorIframes[i].contentWindow.document;
      if (iframeContent) {
        iframeContent.querySelector(".h5p-iframe").classList.add('bg-dark');
      }
    }
  }
});

$(() => {
  initializeVideos();
  learningStep();
  watchVideoTillEnd();
  answerH5P();
  lms3Navigation();
  lms3ImageSpotNavigation();
  stickyHeaderForELearning();
  lms3progress();
});

function initializeVideos() {
  const videoplayerItems = document.querySelectorAll(".videoplayer");

  if (videoplayerItems) {
    for (let i = 0; i < videoplayerItems.length; i++) {
      new Videoplayer(videoplayerItems[i].id, {
        selectors: {
          video: '.video',
          playPauseButton: '.btn-video-playpause',
          playIcon: '.bi-play-fill',
          pauseIcon: '.bi-pause-fill',
          progress: '.progress',
          progressbar: '.progress-bar',
          pipButton: '.btn-video-pip',
          fullscreenButton: '.btn-video-fullscreen',
          volumeRange: '.form-range-volume'
        }
      })
    }
  }

  /* Auto-hide controls after inactivity */
  const videoplayers = document.querySelectorAll(".videoplayer");

  videoplayers.forEach(player => {
    const controls = player.querySelector("div.controls");
    if (!controls) return;

    let hideTimeout;

    const startHideTimer = () => {
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => {
        controls.classList.add("auto-hide");
      }, 3000);
    };

    const showControls = () => {
      controls.classList.remove("auto-hide");
      startHideTimer();
    };

    // Mausbewegung oder Klick irgendwo im Videoplayer → Controls zeigen
    player.addEventListener("mousemove", showControls);
    player.addEventListener("click", showControls);

    // Timer initial starten
    startHideTimer();
  });

}

function learningStep() {
  // Learning Step Buttons available?
  const nextsteps = document.querySelectorAll(".learning-step-button-container");

  if (nextsteps.length <= 0) {
    return;
  }

  nextsteps[nextsteps.length - 1].classList.add("last-step");

  // Only one learning step element available
  if (nextsteps.length === 1) {
    return;
  }

  // More than one learning step elements available
  nextsteps[nextsteps.length - 2].classList.add("before-last-step");

  // check if last-step is clicked
  let laststepclicked = false;
  document.querySelector(".learning-step-button-container.before-last-step .learning-step-button").addEventListener("click", function () {
    laststepclicked = true;
    document.querySelector(".course-navigation.arrows .btn-next").classList.remove("prevent-default");
  });

  // validate btn next page
  const $nextButton = $('.course-navigation.arrows .btn-next');
  if ($nextButton.length) {
    $nextButton.addClass('prevent-default');
    $nextButton.click((e) => {
      if (laststepclicked) {
        return true;
      }
      e.preventDefault();
      return false;
    });
  }

  // Run through all steps
  $('.learning-step-button').each(function () {
    // Go to next Learning Step Container and hide the current button
    $(this).click(function () {
      $(this).closest('.section-learning-step').next('.section-learning-step').toggleClass('show');
      $(this).closest('.learning-step-button-container').toggleClass('hide');
      $('html,body').animate({
        scrollTop: $(this).closest('.section-learning-step').next('.section-learning-step').offset().top - 220
      }, 'easeOutExpo');
    });
  });
}

// Add watch till end video functionality to Learning Step
function watchVideoTillEnd() {
  const videoplayers = document.querySelectorAll(".section-learning-step .videoplayer");

  videoplayers.forEach(videoplayer => {

    const learningStepButtonContainer = videoplayer.nextElementSibling;
    const videoplayerSrc = videoplayer.querySelector("source").getAttribute('src').split('/').pop();

    // Check if skip-watch-till-end active
    if (videoplayer.closest(".skip-watch-till-end")) {
      return; // Skip this iteration if skip-watch-till-end found
    }

    if (learningStepButtonContainer.classList.contains('learning-step-button-container')) {

      fetch(`?type=1697460926&action=get&key=${videoplayerSrc}`)
        .then(response => response.json())
        .then(data => {
          if (data.value === 0) {
            learningStepButtonContainer.classList.add('prevent-default', 'video');
            videoplayer.querySelector("video").addEventListener("ended", () => {
              learningStepButtonContainer.classList.remove('prevent-default', 'video');
              fetch(`?type=1697460926&action=set&key=${videoplayerSrc}&value=100`, {
                method: 'POST'
              })
            });
          }
        });
    }
  });
}

function busywaitFunction(conditionCallback, actionCallback, timeout) {
  if (conditionCallback()) {
    actionCallback();
  } else {
    setTimeout(() => busywaitFunction(conditionCallback, actionCallback, timeout), timeout);
  }
}

// Add answer H5P Question functionality to Learning Step
function answerH5P() {
  const h5pLearningSteps = document.querySelectorAll(".section-learning-step.h5p-element");

  h5pLearningSteps.forEach(h5pLearningStep => {
    const h5pLearningStepButtonContainer = h5pLearningStep.querySelector(".learning-step-button-container");
    h5pLearningStepButtonContainer.classList.add('prevent-default', 'h5p');

    const h5pIframe = h5pLearningStep.querySelector(".h5p-iframe");
    h5pIframe.addEventListener("load", function () {
      const iframeDocument = h5pIframe.contentDocument || h5pIframe.contentWindow.document;
      busywaitFunction(
        () => iframeDocument.querySelector(".h5p-question-buttons"),
        () => busywaitFunction(
          () => iframeDocument.querySelector(".h5p-question-buttons").childNodes.length === 0,
          () => h5pLearningStepButtonContainer.classList.remove('prevent-default', 'h5p'),
          500
        ),
        5000
      );
    });
  });
}

/* Add visited functionality to System Solutions Image Navigation*/
function lms3Navigation() {
  function delayedNav() {
    const courseNavigationItems = document.querySelectorAll(".course-navigation-item.visited a");
    const systemSolutionsImageNavigationItems = document.querySelectorAll(".elearning-system-solutions-image-navigation .link-item a");
    const linkItemLastPage = document.querySelector(".elearning-system-solutions-image-navigation .link-item.final-page");

    if (systemSolutionsImageNavigationItems.length > 0) {
      courseNavigationItems.forEach(courseNavigationItem => {
        const linksToCheck = [
          ".link-item.welcome",
          ".link-item.track-solutions",
          ".link-item.signaling",
          ".link-item.turnouts",
          ".link-item.rail",
          ".link-item.fastenings",
        ];
        const title = courseNavigationItem.getAttribute('title');
        linksToCheck.forEach(selector => {
          const elem = document.querySelector(".elearning-system-solutions-image-navigation " + selector);
          if (elem && title === elem.children[0].getAttribute('title')) {
            elem.classList.add("visited");
          }
        })
      });
    }

    // Make last page link visible after visiting all content pages
    const systemSolutionsImageNavigationVisitedItems = document.querySelectorAll(".elearning-system-solutions-image-navigation .link-item.visited");
    if (systemSolutionsImageNavigationVisitedItems.length === systemSolutionsImageNavigationItems.length - 1) {
      linkItemLastPage.classList.add("visible");
    }
  }

  setTimeout(delayedNav, 2000);
}

/* Add visited functionality to Image Spot Navigation*/
function lms3ImageSpotNavigation() {
  function delayedNav() {
    const courseNavigationItems = document.querySelectorAll(".course-navigation-item.visited a");
    const imageSpotNavigationItemsLinks = document.querySelectorAll(".elearning-image-spot-navigation .link-item a");
    const linkItemLastPage = document.querySelector(".elearning-image-spot-navigation .link-item.final-page");

    if (imageSpotNavigationItemsLinks.length > 0) {
      courseNavigationItems.forEach(courseNavigationItem => {
        const title = courseNavigationItem.getAttribute('title');
        const imageSpotNavigationItems = document.querySelectorAll(".elearning-image-spot-navigation .link-item");
        imageSpotNavigationItems.forEach(imageSpotNavigationItem => {
          if (imageSpotNavigationItem && title === imageSpotNavigationItem.children[0].getAttribute('title')) {
            imageSpotNavigationItem.classList.add("visited");
          }
        })
      });
    }

    // Make last page link visible after visiting all content pages
    const imageSpotNavigationVisitedItems = document.querySelectorAll(".elearning-image-spot-navigation .link-item.visited");
    if (imageSpotNavigationVisitedItems.length === imageSpotNavigationItemsLinks.length - 1) {
      linkItemLastPage.classList.add("visible");
    }
  }

  setTimeout(delayedNav, 2000);
}

/* Add sticky header menu in elearning section */
function stickyHeaderForELearning() {
  // When the user scrolls the page, execute myFunction
  // Get the header
  const elearningMenuProgress = document.getElementById("elearning-menu-progress");

  if (elearningMenuProgress) {
    let sticky = elearningMenuProgress.offsetTop;

    window.addEventListener('scroll', () => {
      elearningMenuProgress.classList.toggle("sticky", window.scrollY > sticky)
    });
  }
}

function lms3progress()
{
  let courseTitleElem = document.getElementById('header-course-title');
  if (!courseTitleElem) {
    return;
  }

  fetch(`?type=11556611&mount=${courseTitleElem.dataset.courseMount}`)
    .then(response => response.json())
    .then(percent => {
      const progress = document.getElementById('progress-bar');
      const progressSpan = document.getElementById('progress-value');

      progress && (progress.style.width = percent + '%');
      progressSpan && (progressSpan.textContent = percent + '%');
    });
}
